import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Calculatrice — paie/calcul d'heures duotone */
export const CalculatorIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Écran menthe */}
      <rect x="5.5" y="5" width="13" height="4" rx="1" fill="var(--equiply-icon-bg)" />
      {/* Boîtier */}
      <rect x="4.5" y="3" width="15" height="18" rx="2" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Écran contour */}
      <rect x="5.5" y="5" width="13" height="4" rx="1" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Touches : 3 lignes de 3 + 1 large égal */}
      <circle cx="8" cy="12.5" r="0.8" fill="var(--equiply-icon-fg)" />
      <circle cx="12" cy="12.5" r="0.8" fill="var(--equiply-icon-fg)" />
      <circle cx="16" cy="12.5" r="0.8" fill="var(--equiply-icon-fg)" />
      <circle cx="8" cy="15.5" r="0.8" fill="var(--equiply-icon-fg)" />
      <circle cx="12" cy="15.5" r="0.8" fill="var(--equiply-icon-fg)" />
      <circle cx="16" cy="15.5" r="0.8" fill="var(--equiply-icon-fg)" />
      <path d="M7 18.5h10" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
);
CalculatorIcon.displayName = "CalculatorIcon";
